function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Artboard");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Artboard",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "logo",
  transform: "translate(3.000000, 3.000000)"
}, React.createElement("path", {
  d: "M31.523619,23.9830165 L31.5242928,24.0788051 C31.5242928,29.7455628 26.9229685,34.3393776 21.2469473,34.3393776 C17.455321,34.3393776 14.1432614,32.2894594 12.362014,29.2391529 C11.2318731,29.7820686 9.9648121,30.0862906 8.62658012,30.0862906 C3.86225148,30.0862906 0,26.2303424 0,21.4737893 C0,17.7175465 2.40859159,14.5229422 5.76796381,13.3454084 C5.68684148,12.9128792 5.64455243,12.4667054 5.64455243,12.0106706 C5.64455243,8.01751489 8.88693638,4.78042261 12.8866197,4.78042261 C13.8536452,4.78042261 14.7764024,4.96964812 15.6197695,5.31303456 C16.7629587,3.40206765 18.8552492,2.1222432 21.2469473,2.1222432 C23.6115401,2.1222432 25.6834731,3.3732232 26.8349759,5.24843709 C27.775157,4.94452028 28.7785221,4.78042261 29.820277,4.78042261",
  id: "cloud",
  stroke: "#FFFFFF",
  strokeWidth: 1.732104,
  strokeLinecap: "square"
}), React.createElement("g", {
  id: "Group-4",
  transform: "translate(13.163990, 0.736560)"
}, React.createElement("circle", {
  id: "Oval",
  stroke: "#FFFFFF",
  strokeWidth: 1.732104,
  cx: 3.7240236,
  cy: 14.289858,
  r: 2.8579716
}), React.createElement("circle", {
  id: "Oval",
  stroke: "#FFFFFF",
  strokeWidth: 1.3856832,
  cx: 12.8175696,
  cy: 21.6513,
  r: 2.0785248
}), React.createElement("circle", {
  id: "Oval",
  stroke: "#FFFFFF",
  strokeWidth: 1.732104,
  cx: 25.8949548,
  cy: 22.4307468,
  r: 2.8579716
}), React.createElement("circle", {
  id: "Oval",
  stroke: "#FFFFFF",
  strokeWidth: 1.3856832,
  cx: 19.1397492,
  cy: 10.4792292,
  r: 1.9919196
}), React.createElement("circle", {
  id: "Oval",
  stroke: "#FFFFFF",
  strokeWidth: 1.732104,
  cx: 30.9180564,
  cy: 3.7240236,
  r: 2.8579716
}), React.createElement("circle", {
  id: "Oval",
  fill: "#FFFFFF",
  transform: "translate(15.386184, 11.079224) rotate(-192.000000) translate(-15.386184, -11.079224) ",
  cx: 15.3861841,
  cy: 11.0792243,
  r: 1
}), React.createElement("circle", {
  id: "Oval",
  fill: "#FFFFFF",
  transform: "translate(13.014229, 11.583399) rotate(-192.000000) translate(-13.014229, -11.583399) ",
  cx: 13.0142294,
  cy: 11.5833988,
  r: 1
}), React.createElement("circle", {
  id: "Oval",
  fill: "#FFFFFF",
  transform: "translate(8.259234, 12.594104) rotate(-192.000000) translate(-8.259234, -12.594104) ",
  cx: 8.25923448,
  cy: 12.5941042,
  r: 1
}), React.createElement("circle", {
  id: "Oval",
  fill: "#FFFFFF",
  transform: "translate(10.642275, 12.087573) rotate(-192.000000) translate(-10.642275, -12.087573) ",
  cx: 10.6422746,
  cy: 12.0875733,
  r: 1
}), React.createElement("circle", {
  id: "Oval",
  fill: "#FFFFFF",
  transform: "translate(17.221579, 13.962494) rotate(-240.000000) translate(-17.221579, -13.962494) ",
  cx: 17.2215793,
  cy: 13.9624937,
  r: 1
}), React.createElement("circle", {
  id: "Oval",
  fill: "#FFFFFF",
  transform: "translate(16.009107, 16.062558) rotate(-240.000000) translate(-16.009107, -16.062558) ",
  cx: 16.0091065,
  cy: 16.0625582,
  r: 1
}), React.createElement("circle", {
  id: "Oval",
  fill: "#FFFFFF",
  transform: "translate(14.796634, 18.162623) rotate(-240.000000) translate(-14.796634, -18.162623) ",
  cx: 14.7966337,
  cy: 18.1626227,
  r: 1
}), React.createElement("circle", {
  id: "Oval",
  fill: "#FFFFFF",
  transform: "translate(23.470694, 18.214111) rotate(-120.000000) translate(-23.470694, -18.214111) ",
  cx: 23.4706943,
  cy: 18.2141105,
  r: 1
}), React.createElement("circle", {
  id: "Oval",
  fill: "#FFFFFF",
  transform: "translate(22.258221, 16.114046) rotate(-120.000000) translate(-22.258221, -16.114046) ",
  cx: 22.2582215,
  cy: 16.114046,
  r: 1
}), React.createElement("circle", {
  id: "Oval",
  fill: "#FFFFFF",
  transform: "translate(21.045749, 14.013982) rotate(-120.000000) translate(-21.045749, -14.013982) ",
  cx: 21.0457487,
  cy: 14.0139815,
  r: 1
}), React.createElement("circle", {
  id: "Oval",
  fill: "#FFFFFF",
  transform: "translate(22.417326, 8.336258) rotate(-30.000000) translate(-22.417326, -8.336258) ",
  cx: 22.4173263,
  cy: 8.33625795,
  r: 1
}), React.createElement("circle", {
  id: "Oval",
  fill: "#FFFFFF",
  transform: "translate(24.517391, 7.123785) rotate(-30.000000) translate(-24.517391, -7.123785) ",
  cx: 24.5173908,
  cy: 7.12378515,
  r: 1
}), React.createElement("circle", {
  id: "Oval",
  fill: "#FFFFFF",
  transform: "translate(26.617455, 5.911312) rotate(-30.000000) translate(-26.617455, -5.911312) ",
  cx: 26.6174553,
  cy: 5.91131235,
  r: 1
})), React.createElement("path", {
  d: "M54.66704,22.22928 C55.3112,22.22928 56.00024,22.13424 56.73416,21.94416 C57.46808,21.75408 58.15712,21.47952 58.80128,21.12048 L58.80128,21.12048 L58.80128,14.62608 L52.9088,14.62608 L52.9088,16.54272 L56.64704,16.54272 L56.64704,19.94832 C55.98176,20.21232 55.32176,20.34432 54.66704,20.34432 C53.44208,20.34432 52.48904,19.94304 51.80792,19.14048 C51.1268,18.33792 50.78624,17.26608 50.78624,15.92496 C50.78624,15.09072 50.93936,14.34888 51.2456,13.69944 C51.55184,13.05 51.998,12.54048 52.58408,12.17088 C53.17016,11.80128 53.86448,11.61648 54.66704,11.61648 C55.34288,11.61648 55.94216,11.69304 56.46488,11.84616 C56.9876,11.99928 57.51824,12.22368 58.0568,12.51936 L58.0568,12.51936 L58.0568,10.52352 C57.45488,10.25952 56.91368,10.06152 56.4332,9.92952 C55.95272,9.79752 55.364,9.73152 54.66704,9.73152 C53.3048,9.73152 52.16696,10.00608 51.25352,10.5552 C50.34008,11.10432 49.66424,11.8488 49.226,12.78864 C48.78776,13.72848 48.56864,14.78976 48.56864,15.97248 C48.56864,17.21856 48.79832,18.31152 49.25768,19.25136 C49.71704,20.1912 50.40344,20.92248 51.31688,21.4452 C52.23032,21.96792 53.34704,22.22928 54.66704,22.22928 Z M63.31568,21.96 L63.31568,15.79824 C64.14992,15.14352 65,14.81616 65.86592,14.81616 L65.86592,14.81616 L66.23024,14.81616 L66.23024,12.91536 L65.86592,12.91536 C64.97888,12.91536 64.1288,13.2744 63.31568,13.99248 L63.31568,13.99248 L63.31568,13.10544 L61.19312,13.10544 L61.19312,21.96 L63.31568,21.96 Z M72.05936,22.22928 C72.72464,22.22928 73.32128,22.16856 73.84928,22.04712 C74.37728,21.92568 74.89472,21.7224 75.4016,21.43728 L75.4016,21.43728 L74.83136,19.75824 C74.3456,19.99056 73.90736,20.15952 73.51664,20.26512 C73.12592,20.37072 72.72464,20.42352 72.3128,20.42352 C70.70768,20.42352 69.82064,19.62096 69.65168,18.01584 L69.65168,18.01584 L75.59168,18.01584 L75.59168,17.17632 C75.58112,15.76128 75.22472,14.6868 74.52248,13.95288 C73.82024,13.21896 72.85136,12.852 71.61584,12.852 C70.8344,12.852 70.12688,13.03152 69.49328,13.39056 C68.85968,13.7496 68.35808,14.28024 67.98848,14.98248 C67.61888,15.68472 67.43408,16.52688 67.43408,17.50896 C67.43408,18.4488 67.61096,19.27248 67.96472,19.98 C68.31848,20.68752 68.84384,21.23928 69.5408,21.63528 C70.23776,22.03128 71.07728,22.22928 72.05936,22.22928 Z M73.35824,16.36848 L69.73088,16.36848 C69.95264,15.228 70.58096,14.65776 71.61584,14.65776 C72.1544,14.65776 72.56624,14.79504 72.85136,15.0696 C73.13648,15.34416 73.30544,15.77712 73.35824,16.36848 L73.35824,16.36848 Z M79.55168,21.96 L79.55168,15.73488 C80.24864,15.1224 80.94032,14.81616 81.62672,14.81616 C82.19696,14.81616 82.59824,14.96136 82.83056,15.25176 C83.06288,15.54216 83.17904,15.99888 83.17904,16.62192 L83.17904,16.62192 L83.17904,21.96 L85.3016,21.96 L85.3016,16.62192 C85.3016,16.32624 85.28576,16.05168 85.25408,15.79824 C85.98272,15.14352 86.69024,14.81616 87.37664,14.81616 C87.94688,14.81616 88.34816,14.96136 88.58048,15.25176 C88.8128,15.54216 88.92896,15.99888 88.92896,16.62192 L88.92896,16.62192 L88.92896,21.96 L91.05152,21.96 L91.05152,16.62192 C91.05152,15.32304 90.78224,14.38056 90.24368,13.79448 C89.70512,13.2084 88.88672,12.91536 87.78848,12.91536 C87.24992,12.91536 86.74568,13.03152 86.27576,13.26384 C85.80584,13.49616 85.33328,13.84992 84.85808,14.32512 C84.6152,13.83936 84.2588,13.48296 83.78888,13.25592 C83.31896,13.02888 82.73552,12.91536 82.03856,12.91536 C81.17264,12.91536 80.34368,13.248 79.55168,13.91328 L79.55168,13.91328 L79.55168,13.10544 L77.42912,13.10544 L77.42912,21.96 L79.55168,21.96 Z M95.88272,22.16592 C96.29456,22.16592 96.74864,22.10784 97.24496,21.99168 L97.24496,21.99168 L97.24496,20.15424 C96.99152,20.2176 96.70112,20.24928 96.37376,20.24928 C96.0464,20.24928 95.81936,20.17536 95.69264,20.02752 C95.56592,19.87968 95.50256,19.61568 95.50256,19.23552 L95.50256,19.23552 L95.50256,8.55936 L93.38,8.55936 L93.38,19.93248 C93.38,20.6928 93.58064,21.25512 93.98192,21.61944 C94.3832,21.98376 95.0168,22.16592 95.88272,22.16592 Z M101.03072,11.56896 L101.03072,9.17712 L98.90816,9.17712 L98.90816,11.56896 L101.03072,11.56896 Z M101.03072,21.96 L101.03072,13.10544 L98.90816,13.10544 L98.90816,21.96 L101.03072,21.96 Z M106.03616,21.96 L106.03616,15.00624 L107.77856,15.00624 L107.77856,13.10544 L106.03616,13.10544 L106.03616,11.28384 C106.03616,10.90368 106.09688,10.63968 106.21832,10.49184 C106.33976,10.344 106.56944,10.27008 106.90736,10.27008 C107.23472,10.27008 107.52512,10.30176 107.77856,10.36512 L107.77856,10.36512 L107.77856,8.52768 C107.26112,8.41152 106.80704,8.35344 106.41632,8.35344 C105.5504,8.35344 104.9168,8.5356 104.51552,8.89992 C104.11424,9.26424 103.9136,9.82656 103.9136,10.58688 L103.9136,10.58688 L103.9136,13.10544 L102.83648,13.10544 L102.83648,15.00624 L103.9136,15.00624 L103.9136,21.96 L106.03616,21.96 Z M110.13872,25.93584 C110.6984,25.93584 111.1604,25.85928 111.52472,25.70616 C111.88904,25.55304 112.20584,25.29432 112.47512,24.93 C112.7444,24.56568 113.00048,24.0456 113.24336,23.36976 L113.24336,23.36976 L116.96576,13.10544 L114.89072,13.10544 L112.7048,19.09296 L110.67728,13.10544 L108.49136,13.10544 L111.6752,21.96 L111.40592,22.6728 C111.20528,23.2008 110.99144,23.5572 110.7644,23.742 C110.53736,23.9268 110.2232,24.0192 109.82192,24.0192 C109.47344,24.0192 109.1672,23.98224 108.9032,23.90832 L108.9032,23.90832 L108.9032,25.7616 C109.2728,25.87776 109.68464,25.93584 110.13872,25.93584 Z",
  id: "Gremlify",
  fill: "#FFFFFF",
  fillRule: "nonzero"
})));

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "125px",
    height: "40px",
    viewBox: "0 0 125 40",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.59e0bdb8.svg";
export { ForwardRef as ReactComponent };